import { Component, Input, OnInit, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, Inject, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';

import { SHARED_IMPORTS } from '../shared/shared-imports';
import { ContentService } from '../../services/content.service';

@Component({
	selector: 'user-notification-preferences-component',
	standalone: true,
	templateUrl: 'components/user-notification-preferences/user-notification-preferences.component.html',
	imports: [
		...SHARED_IMPORTS,
		MatCardModule,
		MatCheckboxModule,
		MatSlideToggleModule,
		MatButtonModule],
	schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class UserNotificationPreferencesComponent implements OnInit {
	@Input() user: any;
	@Input() locationStructure: any[] = [];
	@Input() isUserDisabled: boolean;

	checkAll: boolean = false;
	userIdParam: any = {};
	getContent: (id: string) => string;

	@Output() uncheckAll = new EventEmitter<boolean>();  // replaces $scope.$emit

	private http = inject(HttpClient);
	private content = inject(ContentService);

	constructor(
		
	) {
		this.getContent = this.content.getContent.bind(this.content);
	}

	ngOnInit(): void {
		// TODO: Get userId parameter from Angular Router if needed
		const userId = this.userIdParam; // Use the @Input parameter instead
		if (userId) {
			this.userIdParam = { userId };
		}

		Promise.all([
			this.http.get('/api/Location/GetAllLocationAreas').toPromise(),
			this.http.get('/api/Notification/GetUserNotificationRules', { params: this.userIdParam }).toPromise()
		]).then(([locRes, notifRes]: any[]) => {
			this.locationStructure = locRes;
			const rules = notifRes;

			this.locationStructure.forEach(location => {
				let locationSelected = true;

				location.Rooms.forEach(room => {
					room.parentLocation = location;
					room.selected = rules.some((v: any) => v.RoomId === room.Id);
					if (!room.selected) locationSelected = false;
				});

				location.selected = locationSelected;
			});

			this.checkAll = this.locationStructure.every(loc =>
				loc.selected && loc.Rooms.every((room: any) => room.selected)
			);

			this.uncheckAll.emit(this.checkAll); // replaces $scope.$emit
		});
	}

	onCheckAll(): void {
		this.locationStructure.forEach(loc => {
			loc.selected = this.checkAll;
			loc.Rooms.forEach(room => {
				room.selected = this.checkAll;
			});
		});

		this.uncheckAll.emit(this.checkAll);
	}

	nodeClick(node: any): void {
		this.checkAll = true;

		if (node.Rooms) {
			node.Rooms.forEach(room => {
				room.selected = node.selected;
				this.checkAll = node.selected;
			});
		} else {
			const parent = node.parentLocation;
			let locationSelected = node.selected;

			if (node.selected) {
				parent.Rooms.forEach(room => {
					if (!room.selected) {
						locationSelected = false;
						this.checkAll = false;
					}
				});
			}

			parent.selected = locationSelected;
		}

		for (let loc of this.locationStructure) {
			if (!loc.selected) {
				this.checkAll = false;
				break;
			}
		}

		this.uncheckAll.emit(this.checkAll);
	}

	toggleAllNodes(selected: boolean): void {
		this.locationStructure.forEach(location => {
			location.Rooms.forEach(room => {
				room.parentLocation = location;
				room.selected = selected;
			});
			location.selected = selected;
		});
	}

	saveNotificationsRules(): void {
		const roomsId: number[] = [];

		this.locationStructure.forEach(location => {
			location.Rooms.forEach(room => {
				if (room.selected) {
					roomsId.push(room.Id);
				}
			});
		});

		const params = { ...this.userIdParam, roomsId };

		this.http.get('/api/Notification/SaveUserNotificationRules', { params }).subscribe();
	}
}
